<template>
  <div class="bg-white shadow-2l p-4 rounded-lg relative flex">
    <span
      v-if="stock"
      class="bg-indigo-100 z-10 text-indigo-700 font-bold px-4 py-2 text-md rounded-lg rounded-b-none m-0 absolute top-0 right-0 rounded-l-none"
      >{{ stock.qty }} Unidades</span
    >
    <div class="p-2 absolute right-0 bottom-0">
      <button
        @click="
          $router.push({
            name: 'store.product.show',
            params: { id: $route.params.id, product: product_id }
          })
        "
        class="focus:outline-none text-lg px-4 py-2 mr-2 bg-indigo-100 text-indigo-600 rounded-full text-center border-2 border-transparent focus:border-indigo-600"
      >
        <font-awesome-icon icon="pen" class="" />
        <ui-tooltip position="bottom" animation="fade">Editar</ui-tooltip>
      </button>
      <button
        @click="$emit('product_deleted', product_id)"
        class="font-medium focus:outline-none px-4 py-2 bg-red-100 text-red-600 text-lg rounded-full text-center border-2 border-transparent focus:border-red-600"
      >
        <font-awesome-icon icon="trash-alt" />
        <ui-tooltip position="bottom" animation="fade">Remover</ui-tooltip>
      </button>
    </div>
    <div class="overflow-hidden">
      <img
        :src="`${$settings.image_url}/${imageThumb}`"
        class="object-cover rounded-lg"
        width="80"
        alt=""
      />
    </div>
    <div class="w-full px-4 ">
      <div class="">
        <h2 class="text-xl text-gray-700 mb-1 truncate">
          {{ !product_name ? 'Rascunho' : product_name }}
        </h2>
        <h3 class="text-2xl font-bold">{{ price | toCurrency }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product_name: {
      type: String,
      default: 'Rascunho'
    },
    price: Number,
    image: {
      type: Object,
      default: () => {
        return {}
      }
    },
    stock: Number,
    product_id: String,
    store_id: String
  },
  computed: {
    imageThumb() {
      if (this.image) {
        return this.image.path
      }
      return 'store/no-image.png'
    }
  }
}
</script>

<style></style>
